<template>
  <div class="mx-5">
    <router-view />
  </div>
</template>